import { render, staticRenderFns } from "./articleSearch.vue?vue&type=template&id=17f1dfeb&scoped=true&"
import script from "./articleSearch.vue?vue&type=script&setup=true&lang=js&"
export * from "./articleSearch.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./articleSearch.vue?vue&type=style&index=0&id=17f1dfeb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f1dfeb",
  null
  
)

export default component.exports